import { NextSeo } from "next-seo";
import Link from "next/link";
import { useRouter } from "next/router";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import Public from "../../Layouts/Public";
import { ActionTitle } from "../../components/ActionWithHint";
import PageSection from "../../components/PageSection";
import Spacer from "../../components/Spacer";
import { siteTitle } from "../../data/PublicSiteData";
import { trackPageView } from "../../includes/analytics";
import { device } from "../../theme/Breakpoints";
import { Color } from "../../theme/Color";

const StyledSignUpCol = styled(Col)`
  min-height: 15vh;

  @media ${device.mdAndWider} {
    min-height: 30vh;
  }
`;

const TravellersPage = () => {
  const router = useRouter();

  trackPageView("/travellers");

  return (
    <>
      <NextSeo
        title={`Travellers | ${siteTitle}`}
        description="Valmeego is a new way for destinations and visitors to connect directly, combined with a user-friendly multi-purpose tool for researching, planning and booking any trip."
      />
      <PageSection fullHeight={true} backgroundColor={Color.White} width="100%">
        <Row middle="xs">
          <Col xs={12}>
            <Spacer top={10} bottom={8}>
              <ActionTitle color={Color.Black}>
                <Link href="/personal/solo-trip">
                  <a>Solo Travelling</a>
                </Link>
              </ActionTitle>
            </Spacer>
          </Col>
        </Row>
        <Row middle="xs">
          <Col xs={12}>
            <Spacer bottom={8}>
              <ActionTitle color={Color.Black}>
                <Link href="/personal/group-trip">
                  <a>Group Travelling</a>
                </Link>
              </ActionTitle>
            </Spacer>
          </Col>
        </Row>
        <Row middle="xs">
          <Col xs={12}>
            <Spacer bottom={8}>
              <ActionTitle color={Color.Black}>
                <Link href="/personal/club-trip">
                  <a>Club Travelling</a>
                </Link>
              </ActionTitle>
            </Spacer>
          </Col>
        </Row>
      </PageSection>
    </>
  );
};

TravellersPage.Layout = Public;
TravellersPage.Title = "Valmeego - Locally and beyond";

export default TravellersPage;
